import type { ComponentType } from 'react';
import {
  type PostContactFlowDefinition,
  postContactFlowRegistry,
  type PostContactFlowType,
} from './postContactFlowRegistry';
import {
  MultiContactStep,
  type PostContactFlowStepProps,
  RenterProfileStep,
  SavedSearchFlowStep,
  SuccessStep,
  WaitlistSuccessStep,
} from './postContactFlowSteps';

export type PostContactFlowConfig = PostContactFlowDefinition & {
  component: ComponentType<PostContactFlowStepProps>;
};

const postContactFlowComponents: Record<PostContactFlowType, ComponentType<PostContactFlowStepProps>> = {
  'renter-profile': RenterProfileStep,
  'saved-search': SavedSearchFlowStep,
  'waitlist-success': WaitlistSuccessStep,
  'multi-contact': MultiContactStep,
  success: SuccessStep,
};

export const postContactFlowConfig: Array<PostContactFlowConfig> = postContactFlowRegistry.map((flow) => ({
  ...flow,
  component: postContactFlowComponents[flow.type],
}));
